import React, { createRef } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BillWatchProps } from "../BillWatchProps";
import { NSBox, NSBoxBaseCombo, NSBoxTextArea, NSButtonGreen, NSChartBar, NSLine, NSPanel, NSRow, NSSection } from "namirasoft-site-react";
import ConditionLine from "../components/ConditionLine";
import { BillWatchSampleData } from "../BillWatchSampleData";
import { StringOperation } from "namirasoft-core";
import { CalculationResult, CostData, Formulas } from "namirasoft-bill-watch";
import { BillWatchLayout } from "../BillWatchLayout";
import CalculationResultView from "../components/CalculationResultView";

interface RuleSimulatorPageProps extends NSARouterMakerResult, BillWatchProps { }

interface RuleSimulatorPageState 
{
	result: CalculationResult | null;
	logs: string;
	all: CostData[];
	data: CostData[];
	value: CostData;
}

class RuleSimulatorPage extends React.Component<RuleSimulatorPageProps, RuleSimulatorPageState>
{
	ConditionLine_Simulate = createRef<ConditionLine>();
	NSBoxTextArea_History = createRef<NSBoxTextArea>();
	NSBoxBaseCombo_Sample = createRef<NSBoxBaseCombo<string>>();

	constructor(props: RuleSimulatorPageProps)
	{
		super(props);
		this.state = { result: null, logs: "", all: [], data: [], value: { amount: 0, time: "", unit: "" } };
	}

	override render()
	{
		return (
			<BillWatchLayout
				{...this.props}
                action={{
                    title: "Simulator",
                    description: "You can test a rule condition with a single sample data set, either by selecting an example or entering data manually."
                }}
			>
				<NSSection>
					<NSPanel>
						<NSRow
							style={{ width: NSBox.width.triple }}
						>
							<ConditionLine
								ref={this.ConditionLine_Simulate}
								{...this.props}
								deletable={false}
								index={null}
								onDelete={() => { }}
								required
								nullable={false}
							></ConditionLine>
							<NSLine />
							<NSRow
								style={{ alignItems: "end" }}
							>
								<NSBoxBaseCombo<string>
									ref={this.NSBoxBaseCombo_Sample}
									title="Sample Data"
									multiple={false}
									required
									searchable={false}
									defaultValue={Object.keys(BillWatchSampleData.List)[0]}
									getSort={() => null}
									getItems={async () =>
									{
										let names = Object.keys(BillWatchSampleData.List);
										return { count: names.length, rows: names }
									}}
									getTitle={item => item}
									getValue={item => item}
								/>
								<NSButtonGreen
									title="Load Sample Data"
									onClick={{
										action: () =>
										{
											try
											{
												let name = this.NSBoxBaseCombo_Sample.current?.getValueOne();
												if (name)
													this.NSBoxTextArea_History.current?.setValue(BillWatchSampleData.List[name].join(" "));
											} catch (error)
											{
												this.props.notifier.onError(error as Error);
											}
										},
										showLoading: false
									}}
								/>
							</NSRow>
							<NSBoxTextArea
								ref={this.NSBoxTextArea_History}
								required
								rows={2}
								title="History"
								style={{ width: "100%" }}
								onChanged={() =>
								{
									let text = this.NSBoxTextArea_History.current?.getValue();
									let all = StringOperation.split(text ?? "").map(t => parseFloat(t)).map(r => { return { amount: r, time: "", unit: "" } });
									let { data, value } = Formulas.getDataValue(all, all[0]);
									this.setState({ all, data, value })
								}}
							/>
							{
								this.state.all.length > 0 &&
								<>
									<NSChartBar
										dataset={[{
											label: "",
											data: this.state.all.map(r => r.amount)
										}]}
										labels={this.state.all.map((_, index) => (index + 1).toString())}
										range={{
											min: Math.min(...this.state.all.map(r => r.amount)) * 0.75,
											max: Math.max(...this.state.all.map(r => r.amount)) * 1.1
										}}
                                        mode={"stacked"}
									/>
									<NSLine />
								</>
							}
							<NSRow
								style={{ alignItems: "end" }}
							>
								<NSButtonGreen
									title="Simulate"
									onClick={{
										action: () =>
										{
											try
											{
												let formula = this.ConditionLine_Simulate.current?.getValue();
												if (formula)
												{
													let result = Formulas.evaluate(this.state.data, this.state.value, formula, true);
													this.setState({ result });
												}
											} catch (error)
											{
												this.setState({ result: null });
												this.props.notifier.onError(error as Error);
											}
										},
										showLoading: false
									}}
								/>
							</NSRow>
							{
								this.state.result &&
								<>
									<NSLine />
									<CalculationResultView
										data={this.state.data}
										value={this.state.value}
										formula={this.ConditionLine_Simulate.current?.getValue()}
										result={this.state.result}
									/>
								</>
							}
						</NSRow>
					</NSPanel>
				</NSSection>
			</BillWatchLayout>
		);
	}
}

export default RuleSimulatorPage;